<div id="events" class="ya-typography">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <nav mat-tab-nav-bar class="ya-tab-nav-bar ya-mat-tab-nav-bar">
      <a mat-tab-link *ngFor="let tabStep of tabeventStep; let tabIndex = index" (click)="changeTab(tabIndex)"
        [active]="activeLink == tabStep">
        <span [langkey]="tabStep"></span>
      </a>
    </nav>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop" (swipeleft)="swipeLeftHandler()"
    (swiperight)="swipeRightHandler()">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="event-map-tabs">
        <mat-tab-group mat-stretch-tabs dynamicHeight="true" [(selectedIndex)]="matGroupSelectedIndex"
          (selectedIndexChange)="changeTab($event)" animationDuration="20ms">

          <mat-tab label="upcoming-events">
            <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
              <ng-container *ngIf="currentEventList.length>0; then currentTabContent else emptyTab"></ng-container>
              <ng-template #currentTabContent>
                <div class="ya-item-list-container" #eventListView>
                  <ng-container *ngFor="let currentEvent of currentEventList">
                    <div class="ya-content-item event-item event-button">
                      <div class="left" (click)="navigateToEventDetail(currentEvent.id)">

                        <div class="event-like-wrapper ya-caption">
                          <span>
                            {{currentEvent.startDayMonth}}
                          </span>
                          <span>
                            {{currentEvent.startYear}}
                          </span>
                          <ng-container
                            *ngIf="currentEvent.endDate; then endDateContent else emptyEndDateContent"></ng-container>
                          <ng-template #endDateContent>
                            <span>
                              -
                            </span>
                            <span>
                              {{currentEvent.endDayMonth}}
                            </span>
                            <span>
                              {{currentEvent.endYear}}
                            </span>
                          </ng-template>
                          <ng-template #emptyEndDateContent></ng-template>
                        </div>
                        <div class="aspect-ratio-box">
                          <div class="aspect-ratio-box-inside">
                            <div class="aspect-ration-img-box">
                              <img class="ya_image" [src]="currentEvent.image_photo" alt="" />
                            </div>
                          </div>
                        </div>
                        <div class="event-content" (click)="navigateToEventDetail(currentEvent.id)">
                          <div class="event-content-wrapper">
                            <h2 class="title">
                              {{currentEvent.label}}
                            </h2>
                            <ng-container *ngIf="!isSmallView">
                              <div class="event-content-container">
                                <p class="content-text" [innerHTML]="currentEvent.text"></p>
                                <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-events">
                                </div>
                              </div>
                            </ng-container>
                            <div class="event-content-services"></div>
                          </div>
                          <div class="event-content-detail-wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
              <ng-template #emptyTab>
                <ya-emptypage emptyTitle="phEmptyTab_Title" emptyContent="phEmptyTab_Content"></ya-emptypage>
              </ng-template>
            </div>
          </mat-tab>

          <mat-tab label="expired-event">
            <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
              <ng-container *ngIf="expiredEventList.length>0; then expiredTabContent else emptyTab"></ng-container>
              <ng-template #expiredTabContent>
                <div class="ya-item-list-container" #eventListView>
                  <ng-container *ngFor="let expiredEvent of expiredEventList">
                    <div class="ya-content-item event-item">
                      <div class="left" (click)="navigateToEventDetail(expiredEvent.id)">
                        <div class="event-like-wrapper ya-caption">
                          <span>
                            {{expiredEvent.startDayMonth}}
                          </span>
                          <span>
                            {{expiredEvent.startYear}}
                          </span>
                          <ng-container
                            *ngIf="expiredEvent.endDate; then endDateContent else emptyEndDateContent"></ng-container>
                          <ng-template #endDateContent>
                            <span>
                              -
                            </span>
                            <span>
                              {{expiredEvent.endDayMonth}}
                            </span>
                            <span>
                              {{expiredEvent.endYear}}
                            </span>
                          </ng-template>
                          <ng-template #emptyEndDateContent></ng-template>
                        </div>
                        <div class="aspect-ratio-box">
                          <div class="aspect-ratio-box-inside">
                            <div class="aspect-ration-img-box">
                              <img class="ya_image" [src]="expiredEvent.image_photo" alt="" />
                            </div>
                          </div>
                        </div>
                        <div class="event-content" (click)="navigateToEventDetail(expiredEvent.id)">
                          <div class="event-content-wrapper">
                            <h2 class="title">
                              {{expiredEvent.label}}
                            </h2>
                            <ng-container *ngIf="!isSmallView">
                              <div class="event-content-container">
                                <p class="content-text" [innerHTML]="expiredEvent.text"></p>
                                <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-events">
                                </div>
                              </div>
                            </ng-container>

                            <div class="event-content-services"></div>
                          </div>
                          <div class="event-content-detail-wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
              <ng-template #emptyTab>
                <ya-emptypage emptyTitle="phEmptyTab_Title" emptyContent="phEmptyTab_Content"></ya-emptypage>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>